"use client";

import { useTranslations } from "next-intl";
import { WorkspaceSetupLoadingScreen } from "@/app/components/workspace/WorkspaceSetupLoadingScreen";

export default function Loading() {
  const t = useTranslations("common");

  return <WorkspaceSetupLoadingScreen brandLabel={t("brand")} progressLabel={t("loading")} title={t("loading")} />;
}
